import React from 'react';

/**
 * Placeholder shown in the Monthly Pulse modal before a report is generated:
 * a static grid of gray tiles approximating the dashboard layout, with no data.
 */
const MonthlyPulseEmptyState: React.FC = () => (
  <div className='monthly-pulse-empty-state'>
    <div className='monthly-pulse-empty-state__heading' />
    <div className='monthly-pulse-empty-state__tiles'>
      {Array.from({ length: 8 }).map((_, i) => (
        <div key={i} className='monthly-pulse-empty-state__tile' />
      ))}
    </div>
    <div className='monthly-pulse-empty-state__tiles'>
      {Array.from({ length: 4 }).map((_, i) => (
        <div key={i} className='monthly-pulse-empty-state__tile monthly-pulse-empty-state__tile--wide' />
      ))}
    </div>
    <div className='monthly-pulse-empty-state__panels'>
      <div className='monthly-pulse-empty-state__panel'>
        {Array.from({ length: 5 }).map((_, i) => (
          <div key={i} className='monthly-pulse-empty-state__row' />
        ))}
      </div>
      <div className='monthly-pulse-empty-state__panel'>
        {Array.from({ length: 5 }).map((_, i) => (
          <div key={i} className='monthly-pulse-empty-state__row' />
        ))}
      </div>
    </div>
  </div>
);

export default MonthlyPulseEmptyState;
